const SHARE_PATH = "/hotel/book/share";

export function isSharedBookingToken(token: string): boolean {
  return /^[A-Za-z0-9_-]{43}$/.test(token);
}

export function buildSharedBookingUrl(
  token: string | null | undefined
): string | null {
  return token && isSharedBookingToken(token)
    ? `https://www.gondola.ai${SHARE_PATH}/${token}`
    : null;
}

export function isSharedBookingPath(path: string | null): boolean {
  return path === SHARE_PATH || !!path?.startsWith(`${SHARE_PATH}/`);
}

/** Capability URLs must never enter analytics or session recordings. */
export function isPrivateCapabilityPath(path: string | null): boolean {
  return path === "/whatsapp/link" || isSharedBookingPath(path);
}
